import * as React from "react";
import { forwardRef, memo } from "react";
const SvgSave = (props, ref) => (React.createElement("svg", { width: 24, height: 24, viewBox: "0 -960 960 960", ref: ref, ...props },
    React.createElement("path", { d: "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h447q16 0 30.5 6t25.5 17l114 114q11 11 17 25.5t6 30.5v447q0 33-23.5 56.5T760-120zm560-526L646-760H200v560h560zM480-240q50 0 85-35t35-85-35-85-85-35-85 35-35 85 35 85 85 35M280-560h280q17 0 28.5-11.5T600-600v-80q0-17-11.5-28.5T560-720H280q-17 0-28.5 11.5T240-680v80q0 17 11.5 28.5T280-560m-80-86v446-560z" })));
const ForwardRef = forwardRef(SvgSave);
const Memo = memo(ForwardRef);
export default Memo;
